import CryptoJS from 'crypto-js';

const SECRET_KEY = 'mis';

// URL-safe Base64 encode
const base64UrlEncode = (str) =>
  str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

// URL-safe Base64 decode
const base64UrlDecode = (str) =>
  str.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - (str.length % 4)) % 4);

export const encrypt = (text) => {
  try {
    if (typeof text !== 'string') {
      if (text === undefined || text === null) {
        throw new Error('Encrypt input is null or undefined');
      }
      text = JSON.stringify(text); // convert object or number to string
    }

    const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
    return base64UrlEncode(encrypted); // URL-safe encoded string
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

export const decrypt = (cipherText) => {
  try {
    const base64 = base64UrlDecode(cipherText);
    const bytes = CryptoJS.AES.decrypt(base64, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (!decrypted) throw new Error('Invalid decryption or empty result');

    return decrypted;
  } catch (error) {
    alert('Decryption failed: ' + error.message);
    console.error('Decryption error:', error);
    return null;
  }
};
